import React from "react";

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionPrivate } from '../../store/auth';

class TemPermissao extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        permissao: "",
        permissoes: [],
        permissaoBoolean: ""
    }

    render() {

      
        let componente = "";
        const permissao = this.props.permissao;
        const permissoes = this.props.permissoes;
        const permissaoBoolean = this.props.permissaoBoolean;

        if (permissao) {
            if (this.props.auth.user.papel.includes(permissao)) {
                componente = this.props.children;
            }
        }

        if (!permissao && permissoes) {
            for (let papel of permissoes) {
                if (this.props.auth.user.papel.includes(papel)) {
                    componente = this.props.children;
                    break;
                }
            }
        }

        if(permissaoBoolean){
            componente = this.props.children;
        }
       

        return (
            <>{ componente }</>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}

function mapDispatchToProps(dispatch)
{
    return { actions: { auth: bindActionCreators(authActionPrivate, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemPermissao));